import { Component, OnDestroy, OnInit } from '@angular/core';
import { SubSink } from 'subsink';
import { TabularFieldSetFormControl } from './tabular-field-set.control';

@Component({
  selector: 'app-bs-app-launch-tabular-field-set-control',
  templateUrl: './bs-app-launch-tabular-field-set-control.component.html',
  styleUrls: ['./bs-app-launch-tabular-field-set-control.component.scss']
})
export class BsAppLaunchTabularFieldSetControlComponent implements OnInit, OnDestroy {
  formControl: TabularFieldSetFormControl;
  
  private subs = new SubSink();

  constructor() { }

  ngOnInit() {}
  
  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

}
